const constants = {
  title: "Opiniones",
};

export default constants;
